import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetUnopenedInboxItemCountQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetUnopenedInboxItemCountQuery = { __typename?: 'Query', me?: { __typename?: 'AuthenticatedUser', id: string, inbox?: { __typename?: 'UserInbox', id?: string | null, items?: { __typename?: 'InboxItemConnection', totalCount: number } | null } | null } | { __typename?: 'IdentifiedUser', id: string } | null };


export const GetUnopenedInboxItemCount = /*#__PURE__*/ gql`
    query GetUnopenedInboxItemCount($accountId: ID!) {
  me {
    id
    ... on AuthenticatedUser {
      inbox {
        id
        items(
          filters: {accountId: $accountId, opened: false}
          orderBy: []
          page: {first: 0}
        ) {
          totalCount
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetUnopenedInboxItemCountQuery, GetUnopenedInboxItemCountQueryVariables>;

          

          export const useGetUnopenedInboxItemCountQuery = (options?:QueryHookOptions<GetUnopenedInboxItemCountQuery, GetUnopenedInboxItemCountQueryVariables>) => useQuery(GetUnopenedInboxItemCount, options);

          

          export type GetUnopenedInboxItemCountQueryOptions = QueryHookOptions<GetUnopenedInboxItemCountQuery, GetUnopenedInboxItemCountQueryVariables>;

          

          export const useGetUnopenedInboxItemCountLazyQuery = (options?:LazyQueryHookOptions<GetUnopenedInboxItemCountQuery, GetUnopenedInboxItemCountQueryVariables>) => useLazyQuery(GetUnopenedInboxItemCount, options);

          

          export type GetUnopenedInboxItemCountQueryResult = ReturnType<typeof useGetUnopenedInboxItemCountQuery>;

          
